import { HTTPAUTH } from "../lib/httplib"

const state = {
  product_search: []
}

const mutations = {
  set_product_search (state, product_search) {
    state.product_search = product_search
  },
}

const actions = {
  async get_product_search (context, q) {
    await HTTPAUTH.get(`/api/v1/search/product/search?size=10&${q}`)
      .then((resp) => {
        context.commit('set_product_search', resp.data.data);
      });
  },
}

const getters = {
}

export default {
  state, getters, mutations, actions
}